import LoginView from 'components/views/LoginView';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getIsAuthenticated } from 'store/login';
import { getHasUserBeenLoaded, getUserData } from 'store/profile';

export const mapStateToProps = (state) => ({
	isAuthenticated: getIsAuthenticated(state),
	isUserLoaded: getHasUserBeenLoaded(state),
	userData: getUserData(state),
});

export default (connect(mapStateToProps) as any)(withRouter(LoginView as any));
